import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=779ab0d1&scoped=true"
import script from "./UploadButton.vue?vue&type=script&lang=js"
export * from "./UploadButton.vue?vue&type=script&lang=js"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=779ab0d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779ab0d1",
  null
  
)

export default component.exports